import { PaymentCollectionType } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/payment_collection_type_pb'
import { StoreConfig } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/store_config_pb'
import { useMemo } from 'react'

export const useStoreConfigPricing = (
  storeConfig?: StoreConfig,
): { feeDetails: { percent: number; label: string }[] } => {
  return useMemo(() => {
    if (
      storeConfig?.paymentCollectionType !==
      PaymentCollectionType.CAPTURE_DETAILS
    ) {
      return { feeDetails: [] }
    }
    return {
      feeDetails: [
        {
          percent: storeConfig?.lateCancellationFeePercent || 0,
          label: 'Late cancellation',
        },
        {
          percent: storeConfig?.noShowFeePercent || 0,
          label: 'No show',
        },
      ].filter((fee) => fee.percent > 0),
    }
  }, [
    storeConfig?.lateCancellationFeePercent,
    storeConfig?.noShowFeePercent,
    storeConfig?.paymentCollectionType,
  ])
}
